<div class="flex flex-row items-center gap-1 self-center shrink-0 opacity-0 group-hover:opacity-100">
  <button (click)="onCopyClick($event)"
          [attr.aria-label]="copied ? 'Antwort kopiert' : 'Antwort kopieren'"
          [class.text-gray-300]="!copied"
          [class.hover:text-gray-500]="!copied"
          [class.text-gray-600]="copied"
          [tooltip]="copied ? 'Kopiert!' : 'Antwort kopieren'"
          class="w-5 h-5 flex items-center justify-center transition-colors"
          tooltipDirection="left" type="button">
    <fa-icon [class.copy-pop]="copied" [class.text-xs]="copied" [class.text-base]="!copied"
             [icon]="copied ? faCheck : faCopy"></fa-icon>
  </button>
  <button (click)="onTaskClick($event)"
          aria-label="Aufgabe erstellen"
          class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500"
          tooltip="Aufgabe erstellen" tooltipDirection="left" type="button">
    <fa-icon [icon]="faClipboardCheck" class="text-base"></fa-icon>
  </button>
</div>
